import { Type } from '@sinclair/typebox';
import { Access } from '../roles.js';
import { UserRole, UserStatus } from './fortnox-user-schema.js';
import { ListPermissionsModel } from './permission-schema.js';
export const GetAccessTokenRequestSchema = Type.Object({
    authorizationCode: Type.String(),
    redirectUri: Type.String(),
});
export const GetAccessTokenResponseSchema = Type.Object({
    accessToken: Type.String(),
    expiresIn: Type.Number(),
    refreshToken: Type.String(),
    scope: Type.String(),
    tokenType: Type.String(),
});
export const GetRefreshTokenRequestSchema = Type.Object({
    refreshToken: Type.String(),
});
export const GetRefreshTokenResponseSchema = Type.Object({
    accessToken: Type.String(),
    expiresIn: Type.Number(),
    refreshToken: Type.String(),
    scope: Type.String(),
    tokenType: Type.String(),
});
export const SessionUserModel = Type.Object({
    id: Type.String(),
    email: Type.String(),
    name: Type.String(),
    role: Type.Enum(UserRole),
    status: Type.Enum(UserStatus),
    permissions: ListPermissionsModel,
});
export const GetMeResponseSchema = SessionUserModel;
export const GetFortnoxMeResponseSchema = Type.Object({
    fortnoxId: Type.String(),
    email: Type.String(),
    name: Type.String(),
    access: Type.Array(Type.Enum(Access)),
});
